// 学生档案
const managerList = () => import( /* webpackChunkName: "schoolAffairs" */ '@/pages/schoolAffairs/views/saStudent/saManager/List.vue')
const teacherList = () => import( /* webpackChunkName: "schoolAffairs" */ '@/pages/schoolAffairs/views/saStudent/saTeacher/List.vue')
const myManage = () => import( /* webpackChunkName: "schoolAffairs" */ '@/pages/schoolAffairs/views/saStudent/saMyManage/MyManage.vue')
const MyAssociation = () => import( /* webpackChunkName: "schoolAffairs" */ '@/pages/schoolAffairs/views/community/MyAssociation.vue') //社团管理
const MyAssociationList = () => import( /* webpackChunkName: "schoolAffairs" */ '@/pages/schoolAffairs/views/community/MyAssociationList.vue') //社团管理-详情页

//校车管理
const SchoolBusOrder = () => import( /* webpackChunkName: "schoolAffairs" */ '@/pages/schoolAffairs/views/saBus/SchoolBusOrder.vue')
// 宿舍管理
const DormitoryManager = () => import( /* webpackChunkName: "schoolAffairs" */ '@/pages/schoolAffairs/views/dormitoryManager/Index.vue')

// 招生管理
const RecruitStudent = () => import( /* webpackChunkName: "schoolAffairs" */ '@/pages/schoolAffairs/views/saRecruit/RecruitStudent/RecruitStudent.vue')
// 导师管理-我的导师
const MyTutor = () => import( /* webpackChunkName: "schoolAffairs" */ '@/pages/schoolAffairs/views/tutor/MyTutor.vue')
// 导师管理-我的学生
const MyStudent = () => import( /* webpackChunkName: "schoolAffairs" */ '@/pages/schoolAffairs/views/tutor/MyStudent.vue')

// 出入校
const SchoolAccessRecord = () => import( /* webpackChunkName: "schoolAffairs" */ '@/pages/schoolAffairs/views/schoolAccess/SchoolAccessRecord.vue')

//  访客参观预约-
const VisitApply = () => import( /* webpackChunkName: "schoolAffairs" */ '@/pages/schoolAffairs/views/visit/VisitApply.vue')
// 访客详情-
const VisitDetails = () => import( /* webpackChunkName: "schoolAffairs" */ '@/pages/schoolAffairs/views/visit/VisitDetails.vue')
// 访客列表-
const VisitList = () => import( /* webpackChunkName: "schoolAffairs" */ '@/pages/schoolAffairs/views/visit/VisitList.vue')
//  访客操作详情提示-
const VisitSubmission = () => import( /* webpackChunkName: "schoolAffairs" */ '@/pages/schoolAffairs/views/visit/VisitSubmission.vue')
// 访客出入校信息-
const VisitApplyDetails = () => import( /* webpackChunkName: "schoolAffairs" */ '@/pages/schoolAffairs/views/visit/VisitApplyDetails.vue')
//  访客审批员列表
const VisitApprovalList = () => import( /* webpackChunkName: "schoolAffairs" */ '@/pages/schoolAffairs/views/visit/VisitApprovalList.vue')
// 访客邀请
const VisitInvitation = () => import( /* webpackChunkName: "schoolAffairs" */ '@/pages/schoolAffairs/views/visit/visitInvitation/VisitInvitation.vue')
const LaunchInvitationDetails = () => import( /* webpackChunkName: "schoolAffairs" */ '@/pages/schoolAffairs/views/visit/visitInvitation/LaunchInvitationDetails.vue')
const LaunchInvitation = () => import( /* webpackChunkName: "schoolAffairs" */ '@/pages/schoolAffairs/views/visit/visitInvitation/LaunchInvitation.vue')
const VisitInvitationSum = () => import( /* webpackChunkName: "schoolAffairs" */ '@/pages/schoolAffairs/views/visit/visitInvitation/VisitInvitationSum.vue')
const VisitTips = () => import( /* webpackChunkName: "schoolAffairs" */ '@/pages/schoolAffairs/views/visit/visitInvitation/VisitTips.vue')

const schoolAffairs = [
  {
    path: 'managerList',
    name: 'managerList',
    component: managerList,
  },
  {
    path: 'teacherList',
    name: 'teacherList',
    component: teacherList,
  },
  {
    path: 'myManage',
    name: 'myManage',
    component: myManage,
  },
  {
    path: 'MyAssociation',
    name: 'MyAssociation',
    component: MyAssociation,
  },
  {
    path: 'MyAssociationList',
    name: 'MyAssociationList',
    component: MyAssociationList,
  },
  {
    path: 'schoolBusOrder',
    name: 'schoolBusOrder',
    component: SchoolBusOrder,
  },
  {
    path: 'RecruitStudent',
    name: 'RecruitStudent',
    component: RecruitStudent,
  },
  {
    path: 'dormitoryManager',
    name: 'dormitoryManager',
    component: DormitoryManager,
  },
  {
    path: 'MyTutor',
    name: 'MyTutor',
    component: MyTutor,
  },
  {
    path: 'MyStudent',
    name: 'MyStudent',
    component: MyStudent,
  },

  // 出入校
  {
    path: 'schoolAccessRecord',
    name: 'schoolAccessRecord',
    component: SchoolAccessRecord,
  },
  //访客
  {
    path: 'visitApply',
    name: 'visitApply',
    component: VisitApply,
  },
  {
    path: 'visitDetails',
    name: 'visitDetails',
    component: VisitDetails,
  },
  {
    path: 'visitList',
    name: 'visitList',
    component: VisitList,
  },
  {
    path: 'visitSubmission',
    name: 'visitSubmission',
    component: VisitSubmission,
  },
  {
    path: 'visitApplyDetails',
    name: 'visitApplyDetails',
    component: VisitApplyDetails,
  },
  {
    path: 'visitApprovalList',
    name: 'visitApprovalList',
    component: VisitApprovalList,
  },
  //邀请
  {
    path: 'VisitInvitation',
    name: 'VisitInvitation',
    component: VisitInvitation,
  },
  {
    path: 'LaunchInvitationDetails',
    name: 'LaunchInvitationDetails',
    component: LaunchInvitationDetails,
  },
  {
    path: 'LaunchInvitation',
    name: 'LaunchInvitation',
    component: LaunchInvitation,
  },
  {
    path: 'VisitInvitationSum',
    name: 'VisitInvitationSum',
    component: VisitInvitationSum,
  },
  {
    path: 'VisitTips',
    name: 'VisitTips',
    component: VisitTips,
  }
]
export default schoolAffairs;
